module.exports = __webpack_public_path__ + "static/media/windDirectionForecast.35c60347.png";